import { ACCESS_SUCCESS, ACCESS_FAIL, ACCESS_LOADING, ACCESS_RESET } from "../constants/actionTypes";

const initialState = {
  loading: false,
  loaded: false,      // becomes true after first check (success OR fail)
  hasUser: false,     // backend can tell you if mongo user exists
  isSubscribed: false,
  subscriptionStatus: "none", // ✅ new
  nextBilling: null,          // ✅ new (Date string from API)
  subscriptionPlan: "none",
  isVerified: false, 
  reason: null, 
  error: null,
};

export default function access(state = initialState, action) {
  switch (action.type) {
    case ACCESS_LOADING:
      return { ...state, loading: true, error: null };

    case ACCESS_SUCCESS:
      return {
        loading: false,
        loaded: true,
        hasUser: !!action.payload?.hasUser,
        isSubscribed: !!action.payload?.isSubscribed,
        subscriptionStatus: action.payload?.subscriptionStatus ?? "none", // ✅
        nextBilling: action.payload?.nextBilling ?? null,                 // ✅
        subscriptionPlan: action.payload?.subscriptionPlan ?? "none",
        reason: action.payload?.reason ?? null,   
        isVerified: !!action.payload?.isVerified, 
        error: null,
      };

    case ACCESS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        hasUser: false,
        isSubscribed: false,
        subscriptionStatus: "none",
        nextBilling: null,
        reason: null,
        subscriptionPlan: "none",
        error: action.payload?.error || "ACCESS_FAIL",
        isVerified: false, 
      };

    case ACCESS_RESET:
      return initialState;

    default:
      return state;
  }
}
